import React, { useContext } from 'react';
import BarChart from 'components/@common/Charts/BarChart';
import Popover from 'components/@common/Popover';
import Skeleton from 'components/@common/Skeleton';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { PrintViewContext } from '../providers/PrintViewProvider';

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      minHeight: 100,
      height: '100%',
      boxSizing: 'border-box',
      paddingTop: theme.spacing(1),
      paddingRight: theme.spacing(3),
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(3)
    },
    chartContainer: {
      height: '100%',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column'
      }
    },
    chart: {
      minWidth: 200,
      flexGrow: 1
    },
    textContainer: {
      minWidth: 200,
      [theme.breakpoints.up('lg')]: {
        alignSelf: 'flex-end'
      }
    },
    text: {}
  };
});

export interface ChartData {
  total?: number;
  categories?: string[];
  series?: number[];
  renderTextInformation?: any;
}

interface BarChartCardProps extends ChartData {
  title: string;
  yaxisTitle: string;
  helpText?: string;
  loading: boolean;
}

const BarChartCard: React.FC<BarChartCardProps> = ({
  title,
  yaxisTitle,
  helpText,
  total,
  renderTextInformation,
  series,
  categories,
  loading
}) => {
  const classes = useStyles();
  const { cardChartWidth } = useContext(PrintViewContext);
  const titleComponent = (
    <Typography variant="body2" component="h3">
      {title}
    </Typography>
  );

  return (
    <Paper className={classes.container}>
      <Grid container className={classes.chartContainer}>
        <Grid item className={classes.chart}>
          {loading ? (
            <Skeleton height={190} />
          ) : (
            <BarChart
              height={190}
              width={cardChartWidth}
              series={[{ data: series as any }]}
              options={{
                plotOptions: {
                  bar: {
                    columnWidth: '35%',
                    borderRadiusApplication: 'around'
                    // endingShape: 'rounded'
                  }
                },
                dataLabels: { enabled: false },
                legend: { show: false },
                colors: ['#006DB8', '#328AC6', '#65A7D4', '#328AC6', '#98C4E2', '#65A7D4'],
                // labels: { style: { fontSize: '8px' } },
                yaxis: {
                  decimalsInFloat: 0,
                  title: {
                    offsetX: -2,
                    text: yaxisTitle,
                    style: {
                      color: '#373D3F',
                      fontSize: '12px',
                      fontWeight: 700,
                      fontFamily: 'futura-pt'
                    }
                  }
                },
                xaxis: {
                  axisTicks: { show: false },
                  categories: categories,
                  labels: {
                    offsetY: -4,
                    style: {
                      colors: '#373D3F',
                      fontSize: '10px',
                      fontFamily: 'futura-pt'
                    }
                  }
                },
                tooltip: {
                  y: {
                    title: { formatter: (): string => '' }
                  }
                }
              }}
            />
          )}
        </Grid>
        <Grid item className={classes.textContainer}>
          {loading ? (
            <Skeleton height={48} />
          ) : (
            <>
              {helpText ? (
                <Popover description={helpText}>{titleComponent}</Popover>
              ) : (
                titleComponent
              )}
              {renderTextInformation ? (
                renderTextInformation()
              ) : (
                <Typography variant="h2" component="span" className={classes.text}>
                  {total}
                </Typography>
              )}
            </>
          )}
        </Grid>
      </Grid>
    </Paper>
  );
};

export default BarChartCard;
